import React from "react";

import { SonicTermData } from "../../../common/classes/SonicTerm";
import ActionBtn from "../../../common/management/ActionBtn";

import { PageVisibility } from "../../../utils/PageVisibility";
import {
  checkForJikeiRoles,
  genStatusText,
  timestampToTime,
} from "../../../utils/GeneralUtils";

import styles from "../../management/db-list/DBList.module.scss";

type Props = {
  id: string;
  name: string;
  category: SonicTermData;
  author?: { name: string; email: string; roles: Array<string> };
  start_date: number;
  status: string;
};
const TopicsListItem: React.FC<Props> = ({
  id,
  name,
  category,
  author,
  start_date,
  status,
}) => {
  const statusStyle = () => {
    switch (status) {
      case PageVisibility.PubliclyVisible:
        return `${styles["status"]} ${styles["open"]}`;
      case PageVisibility.AwaitingInspection:
        return `${styles["status"]} ${styles["pending"]}`;
      default:
        return `${styles["status"]} ${styles["close"]}`;
    }
  };

  return (
    <div
      className={`${styles["f-dbList__category"]} ${styles["body"]} ${styles["topics"]}`}
    >
      <div>{name}</div>
      <div>{category?.name}</div>
      <div>
        {author?.roles && checkForJikeiRoles(author.roles) ? (
          <span className={styles["userType"]}>{"滋"}</span>
        ) : null}
        {author?.name}
      </div>
      <div>{timestampToTime(start_date, false)}</div>
      <div>
        <span className={statusStyle()}>
          {genStatusText(status, start_date)}
        </span>
      </div>
      <div>
        <ActionBtn
          label="詳細"
          icon={["fal", "edit"]}
          link={`/admin/topics/${id}`}
        />
      </div>
    </div>
  );
};

export default TopicsListItem;
